export const ApibaceUrl = "https://api.themoviedb.org/3";
export const ApiKey = "6bac0fb88dd38981e2a8c7fefe6364e6";
export   const imageUrl ="https://image.tmdb.org/t/p/original";